import { render, staticRenderFns } from "./ProjectManager.vue?vue&type=template&id=470bc292&scoped=true&"
import script from "./ProjectManager.vue?vue&type=script&lang=js&"
export * from "./ProjectManager.vue?vue&type=script&lang=js&"
import style0 from "./ProjectManager.vue?vue&type=style&index=0&id=470bc292&lang=scss&scoped=true&"
import style1 from "./ProjectManager.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470bc292",
  null
  
)

export default component.exports